import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import '../style/components/_cookiesBanner.scss'

const CookiesBanner = ({ forceShow = false, onVisibilityChange }) => {
    const [isVisible, setIsVisible] = useState(forceShow);
    const [, setConsentStatus] = useState(null);

    useEffect(() => {
        const storedConsent = localStorage.getItem("cookie_consent");
        setConsentStatus(storedConsent);
        setIsVisible(forceShow || storedConsent === null)
    }, [forceShow]);

    const updateVisibility = (value) => {
        setIsVisible(value);
        if (onVisibilityChange) {
            onVisibilityChange(value)
        }
    }

    const handleAccept = () => {
        localStorage.setItem("cookie_consent", "granted");
        updateVisibility(false);
        setConsentStatus("granted");
        window[`ga-disable-G-DMFDZSNKC7`] = false;
        ReactGA.initialize("G-DMFDZSNKC7");
    };

    const handleDecline = () => {
        localStorage.setItem("cookie_consent", "denied");
        updateVisibility(false);
        setConsentStatus("denied");
        window[`ga-disable-G-DMFDZSNKC7`] = true;
        
        const removeCookie = (name) => {
            document.cookie = name + '=; Path=/; Domain=' + window.location.hostname.replace('www.', '') + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict; Secure;';
        };

        console.log(window.location.hostname.replace('www.', ''))
        
        // Suppression des cookies GA4
        removeCookie('_ga');
        removeCookie('_ga_DMFDZSNKC7');
        removeCookie('_gat');
        removeCookie('_gid');
    };

    if (!isVisible) return null;

    return (
        <>
            {isVisible && <div className="cookies-modal-overlay">
                <div className="cookies-modal">
                    <h2>Nous utilisons des cookies</h2>
                    <p>Ce site utilise uniquement des cookies de mesures d'audience. Les informations recueillies sont anonymes et ciblent votre parcours de navigation afin d'améliorer, le cas échéant, votre expérience utilisateur.</p>
                    <p>Après avoir effectué votre choix au moyen de la présente bannière, il vous est possible de modifier vos préférences à tout moment en vous rendant sur la page Mentions Légales.</p>
                    <div className="cookies-modal-actions">
                        <button className="btn-accept" onClick={handleAccept}>Accepter</button>
                        <button className="btn-decline" onClick={handleDecline}>Refuser</button>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default CookiesBanner;